// import * as ACTION from '../Actions/actionTypes';
import * as ACTION from "../../actions/UpdateMasterHotel/UpdateMasterHotelActionType"
import { UpdateObject } from "../../../utils/utils";

const initialState = {
  hotelUpdateFlag: false,
};

const UpdateMasterHotelReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.UPDATE_MASTER_HOTEL:
      return updateMasterHotel(state, action);

    default:
      return state;
  }
};

const updateMasterHotel = (state, action) => {
  return UpdateObject(state, {
    hotelUpdateFlag: !state.hotelUpdateFlag,
  });
};

export default UpdateMasterHotelReducer;